import axios from 'axios';

const types = {
    RESULTS: 'history_results',
    CURRENT: 'history_current',
    SUGGESTIONS: 'history_suggestions',
};

const state = {
    [types.RESULTS]: [],
    [types.CURRENT]: null,
    [types.SUGGESTIONS]: [],
};

const mutations = {
    [types.RESULTS](state, rows) {
        state[types.RESULTS] = rows;
    },
    [types.CURRENT](state, row) {
        state[types.CURRENT] = row;
    },
    [types.SUGGESTIONS](state, rows) {
        state[types.SUGGESTIONS] = rows;
    },
};

const getters = {
    historyResults: state => state[types.RESULTS],
    historyCurrent: state => state[types.CURRENT],
    historySuggestions: state => state[types.SUGGESTIONS],
};

const actions = {
    /**
     * Search movix_history by title (substring) or movix_id (numeric).
     * Empty term clears the results without hitting the API.
     */
    searchHistory({ commit }, { term, years } = {}) {
        const trimmed = (term || '').toString().trim();

        if (!trimmed) {
            commit(types.RESULTS, []);
            return Promise.resolve([]);
        }

        const params = /^\d+$/.test(trimmed)
            ? { movix_id: parseInt(trimmed, 10) }
            : { title: trimmed };

        if (years) {
            params.years = years;
        }

        return axios
            .get('/history/admissions/search', { params })
            .then(response => {
                commit(types.RESULTS, response.data.data);
                return response.data.data;
            });
    },

    /**
     * Search the Movix Calendar for titles missing from movix_history.
     * Numeric terms are Movix IDs and have their own compile prompt.
     */
    fetchSuggestions({ commit }, { term, years } = {}) {
        const trimmed = (term || '').toString().trim();

        if (!trimmed || /^\d+$/.test(trimmed)) {
            commit(types.SUGGESTIONS, []);
            return Promise.resolve([]);
        }

        const params = { title: trimmed };

        if (years) {
            params.years = years;
        }

        return axios
            .get('/history/admissions/suggestions', { params })
            .then(response => {
                commit(types.SUGGESTIONS, response.data.data);
                return response.data.data;
            });
    },

    clearSuggestions({ commit }) {
        commit(types.SUGGESTIONS, []);
    },

    /**
     * Fetch a single movix_history record by movix_id.
     */
    fetchHistory({ commit }, movixId) {
        return axios
            .get('/history/admissions/search', { params: { movix_id: movixId } })
            .then(response => {
                const row = response.data.data[0] || null;
                commit(types.CURRENT, row);
                return row;
            });
    },

    /**
     * Recompile movix_history for a single movie and store the fresh record.
     */
    compileHistory({ commit }, movixId) {
        return axios
            .post(`/history/${movixId}/compile`)
            .then(response => {
                commit(types.CURRENT, response.data.data);
                return response.data.data;
            });
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
};
